export const ICONS = {
    search: `<i class="fa-solid fa-magnifying-glass"></i>`,
    delete: `<i class="fa-solid fa-trash"></i>`,
    edit: `<i class="fa-solid fa-pen"></i>`,
    image: `<i class="fa-solid fa-image"></i>`,
    add: `<i class="fa-solid fa-plus"></i>`,
    addCircle: `<i class="fa-solid fa-circle-plus"></i>`,
    save: `<i class="fa-solid fa-save"></i>`,
    cancel: `<i class="fa-solid fa-times"></i>`,
    sortAscending: `<i class="fa-solid fa-sort-alpha-up"></i>`,
    config: `<i class="fa-solid fa-gear"></i>`,
    games: `<i class="fa-solid fa-gamepad"></i>`,
    settings: `<i class="fa-solid fa-cog"></i>`,
    info: `<i class="fa-solid fa-info"></i>`,
    exit: `<i class="fa-solid fa-door-closed"></i>`,
    refresh: `<i class="fa-solid fa-redo"></i>`,
    export: `<i class="fa-solid fa-download"></i>`,
    persons: `<i class="fa-solid fa-user-group"></i>`,
    user: `<i class="fa-solid fa-user-large"></i>`,
    graf: `<i class="fa-solid fa-chart-pie"></i>`,
    calendar: `<i class="fa-solid fa-calendar-alt"></i>`,
    map: `<i class="fa-solid fa-map-marked"></i>`,
    mapPin: `<i class="fa-solid fa-map-pin"></i>`,
    mapMarker: `<i class="fa-solid fa-map-marker-alt"></i>`,
    mapLocation: `<i class="fa-solid fa-location-arrow"></i>`,
    trx: `<i class="fa-solid fa-chart-column"></i>`,
    list: `<i class="fa-solid fa-list-ul"></i>`,
    grid: `<i class="fa-solid fa-th-large"></i>`,
    report: `<i class="fa-solid fa-file-alt"></i>`,
    reportTable: `<i class="fa-solid fa-table"></i>`,
    reportPie: `<i class="fa-solid fa-chart-pie"></i>`,
    database: `<i class="fa-solid fa-database"></i>`,
    protect: `<i class="fa-solid fa-shield"></i>`,
    lock: `<i class="fa-solid fa-lock"></i>`,
    unlock: `<i class="fa-solid fa-unlock-alt"></i>`,
    userAdd: `<i class="fa-solid fa-user-plus"></i>`,
    userRemove: `<i class="fa-solid fa-user-minus"></i>`,
    userEdit: `<i class="fa-solid fa-user-edit"></i>`,
    userLock: `<i class="fa-solid fa-user-lock"></i>`,
    userUnlock: `<i class="fa-solid fa-user-unlock"></i>`,
    userSettings: `<i class="fa-solid fa-user-cog"></i>`,
    userHelp: `<i class="fa-solid fa-question-circle"></i>`,
    userLogout: `<i class="fa-solid fa-sign-out-alt"></i>`,
    eye: `<i class="fa-solid fa-eye"></i>`,
    bug: `<i class="fa-solid fa-bug"></i>`,
    clipboard: `<i class="fa-solid fa-clipboard-list"></i>`,
    desktop: `<i class="fa-solid fa-desktop"></i>`,
    mobile: `<i class="fa-solid fa-mobile"></i>`,
    reload: `<i class="fa-solid fa-rotate-right"></i>`,
    up: `<i class="fa-solid fa-up-long"></i>`,
    down: `<i class="fa-solid fa-down-long"></i>`,
    left: `<i class="fa-solid fa-left-long"></i>`,
    right: `<i class="fa-solid fa-right-long"></i>`,
    leftRight: `<i class="fa-solid fa-arrows-h"></i>`,
    upDown: `<i class="fa-solid fa-arrows-v"></i>`,
    minus: `<i class="fa-solid fa-minus"></i>`,
    filter: `<i class="fa-solid fa-filter"></i>`,
    funnelCircleX: `<i class="fa-solid fa-filter-circle-xmark"></i>`,
    funnelCircleCheck: `<i class="fa-solid fa-filter-circle-check"></i>`,
    xmark: `<i class="fa-solid fa-xmark"></i>`,
    check: `<i class="fa-solid fa-check"></i>`,
    checkDouble: `<i class="fa-solid fa-check-double"></i>`,
    circleCheck: `<i class="fa-solid fa-circle-check"></i>`,
    circleExclamation: `<i class="fa-solid fa-circle-exclamation"></i>`,
    circleInfo: `<i class="fa-solid fa-circle-info"></i>`,
    arrowRotateRight: `<i class="fa-solid fa-arrow-rotate-right"></i>`,
    rotateRight: `<i class="fa-solid fa-rotate-right"></i>`,
    arrowsRotate: `<i class="fa-solid fa-arrows-rotate"></i>`,
    rightFromBracket: `<i class="fa-solid fa-right-from-bracket"></i>`,
    rightToBracket: `<i class="fa-solid fa-right-to-bracket"></i>`,
    floppy: `<i class="fa-solid fa-floppy-disk"></i>`,
    shareFromSquare: `<i class="fa-solid fa-share-from-square"></i>`,
    copy: `<i class="fa-solid fa-copy"></i>`,
    paste: `<i class="fa-solid fa-paste"></i>`,
    calendarDays: `<i class="fa-solid fa-calendar-days"></i>`,
    clock: `<i class="fa-solid fa-clock"></i>`,
    play: `<i class="fa-solid fa-play"></i>`,
    pause: `<i class="fa-solid fa-pause"></i>`,
    stop: `<i class="fa-solid fa-stop"></i>`,
    locationDot: `<i class="fa-solid fa-location-dot"></i>`,
    magnifyingGlass: `<i class="fa-solid fa-magnifying-glass"></i>`,
    tableCellsLarge: `<i class="fa-solid fa-table-cells-large"></i>`,
    tableList: `<i class="fa-solid fa-table-list"></i>`,
    sort: `<i class="fa-solid fa-sort"></i>`,
    sortUp: `<i class="fa-solid fa-sort-up"></i>`,
    sortDown: `<i class="fa-solid fa-sort-down"></i>`,
    userPen: `<i class="fa-solid fa-user-pen"></i>`,
    userSlash: `<i class="fa-solid fa-user-slash"></i>`,
    users: `<i class="fa-solid fa-users"></i>`,
    shield: `<i class="fa-solid fa-shield"></i>`,
    clean: `<i class="fa-solid fa-broom"></i>`,
    firstPage: `<i class="fa-solid fa-angles-left"></i>`,
    prevPage:  `<i class="fa-solid fa-angle-left"></i>`,
    nextPage:  `<i class="fa-solid fa-angle-right"></i>`,
    lastPage:  `<i class="fa-solid fa-angles-right"></i>`,
};